import { T } from "../i18n";
import type { Severity } from "../api/types";
import { COMMUNITY_TONES, PROVENANCE_COLOR, SEVERITY_COLOR } from "../graph/palette";

// Explorer legend: provenance of the edges actually drawn (colors come from the
// same palette the canvas uses, so the legend can never drift from the picture).
const ITEMS: { key: keyof typeof T.provenanceLabel; color: string }[] = [
  { key: "extracted", color: PROVENANCE_COLOR.extracted },
  { key: "inferred", color: PROVENANCE_COLOR.inferred },
  { key: "ambiguous", color: PROVENANCE_COLOR.ambiguous },
];

export function Legend() {
  return (
    <div className="legend" aria-label={T.map.legend}>
      <span className="legend-title">{T.map.legend}</span>
      <ul>
        {ITEMS.map((it) => (
          <li key={it.key}>
            <span className="legend-swatch" style={{ background: it.color }} aria-hidden="true" />
            {T.provenanceLabel[it.key]}
          </li>
        ))}
      </ul>
    </div>
  );
}

// System map legend: describes exactly the encodings the map draws. Severity
// entries appear only for severities present, so the legend never implies data.
export function MapLegend({ severities }: { severities: Severity[] }) {
  return (
    <div className="legend" aria-label={T.map.legend}>
      <ul>
        <li>
          <span className="legend-size" aria-hidden="true"><i /><i /><i /></span>
          Size: connections
        </li>
        <li>
          <span className="legend-tones" aria-hidden="true">
            {COMMUNITY_TONES.slice(0, 4).map((c) => <i key={c} style={{ background: c }} />)}
          </span>
          Color: community
        </li>
        {severities.length ? (
          severities.map((s) => (
            <li key={s}>
              <span className="legend-dot legend-glow" style={{ background: SEVERITY_COLOR[s], color: SEVERITY_COLOR[s] }} aria-hidden="true" />
              {s} finding
            </li>
          ))
        ) : (
          <li className="legend-muted">No confirmed findings yet: types with one turn their severity color</li>
        )}
        <li>
          <span className="legend-ring legend-ring-dashed" aria-hidden="true" />
          Affected set
        </li>
      </ul>
    </div>
  );
}
